import React from 'react'
import Home from './sections/Home.tsx'
import Experience from './sections/Experience.tsx'
import Projects from './sections/Projects.tsx'
import Education from './sections/Education.tsx'

function App() {
  return (
    <div className="App">
      <Home />
      <Experience />
      <Projects />
      <Education />
    </div>
  );
}

export default App;
